import { defineComponent as n, useCssModule as o, inject as m, createElementBlock as l, openBlock as c, normalizeClass as r, unref as t, createVNode as u } from "vue";
import i from "./Icon.js";
import { T as s } from "./ThumbnailGroup.keys-EJ4qFNhx.js";
import { _ as p } from "./_plugin-vue_export-helper-CHgC5LLL.js";
const _ = /* @__PURE__ */ n({
  __name: "ThumbnailEmpty",
  setup(f) {
    const a = o(), { radius: e } = m(s.key, s.defaults);
    return (y, b) => (c(), l("li", {
      class: r(["stash-thumbnail-empty", [
        t(a)["thumbnail-empty"],
        {
          "tw-rounded-full": t(e) === "circle",
          "tw-rounded": t(e) === "rounded"
        }
      ]]),
      "data-test": "stash-thumbnail-empty"
    }, [
      u(i, {
        name: "image",
        "data-test": "stash-thumbnail-empty|icon"
      })
    ], 2));
  }
}), d = {
  "thumbnail-empty": "_thumbnail-empty_1c6pl_2"
}, h = {
  $style: d
}, M = /* @__PURE__ */ p(_, [["__cssModules", h]]);
export {
  M as default
};
//# sourceMappingURL=ThumbnailEmpty.js.map
